// style map
export const StyleMap = {
  fontFamily: 'font-family',
  textAlign: 'text-align',
  paddingRight: 'padding-right',
  paddingLeft: 'padding-left',
  lineHeight: 'line-height',
  fontSize: 'font-size',
  color: 'color',
  backgroundColor: 'background-color',
  textDecoration: 'text-decoration',
  textIndent: 'text-indent',
  borderColor: 'border-color',
  height: 'height',
  width: 'width',
  fontWeight: 'font-weight',
  verticalAlign: 'vertical-align',
  lineThrough: 'line-through',
  underline: 'underline',
  fontStyle: 'font-style',
  subScript: 'subscript',
  superScript: 'superscript',
};
